import react from "react";
import './css/styles.css'; //imports local css

const Footer = () => {
    return <div>This is footer
    </div>;

};

export default Footer;